<!-- createBusinessAccount -->
<div class="accountCreate-progresscircle">
    <!-- Add this inside your register component HTML file -->
    <div role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="--value:100">
        <p class="fs-32 fw-500 mb-0">{{ displayValue }}%</p>
    </div>
      <div *ngIf="showFirstParagraph">
        <p class="fs-20 fw-400 mb-0 display-para">Creating your account... please wait</p>
      </div>
      <div *ngIf="showSecondParagraph">
        <p class="fs-20 fw-400 mb-0 display-para">Your account has been successfully created</p>
      </div>
</div>